import { render, staticRenderFns } from "./UnsupportedBrowser.vue?vue&type=template&id=28ba6974&scoped=true"
import script from "./UnsupportedBrowser.vue?vue&type=script&lang=js"
export * from "./UnsupportedBrowser.vue?vue&type=script&lang=js"
import style0 from "./UnsupportedBrowser.vue?vue&type=style&index=0&id=28ba6974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ba6974",
  null
  
)

export default component.exports